import { RowCard } from '@/components/ui/data-display/cards/RowCard';

export const FigureItem = ({ data }) => {
  const imagePrefix = '';

  return (
    <RowCard
      data={{
        img_mini_card: data?.fields?.img_figure
          ? imagePrefix + data?.fields?.img_figure
          : undefined,
        title: data?.fields?.title,
        alt_img: data?.fields?.alt_img,
        label: data?.fields?.label,
      }}
    />
  );
};
